define('vspot-angular/resources/utilities-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/api/utilities/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                getBatonURL: {
                    method: 'GET',
                    params: {
                        controller: 'baton'
                    },
                    cache:  true
                },
                
                getUrls: {
                    method: 'GET',
                    params: {
                        controller: 'geturls'
                    },
                    cache: true

                },

                getInvitationLink: {
                    method: 'GET',
                    params: {
                        controller: 'generate_invitation_link'
                    },
                    interceptor: {
                        response: function(response) {
                            // Strip off the domain part of the long link
                            if( response && response.resource && response.resource.status && response.resource.longlink && response.resource.longlink.indexOf('://') !== -1 ) {
                                // We should have a long link to update
                                // Find the :// and get rid of that
                                var rest = response.resource.longlink.substring( response.resource.longlink.indexOf('://') + 3 );

                                // Find the new first slash and get rid of whats in front of it
                                response.resource.longlink = rest.substring( rest.indexOf('/') );
                            }

                            return response.resource;
                        }
                    }
                },

                setEmailPreferences: {
                    method: 'POST',
                    params: {
                        controller: 'set_email_preferences'
                    }
                },

                getEmailPreferences: {
                    method: 'GET',
                    params: {
                        controller: 'get_email_preferences'
                    }
                },

                copyActivity: {
                    method: 'POST',
                    params: {
                        controller: 'copyactivity'
                    }
                },

                yahooProxy: {
                    method: 'POST',
                    params: {
                        controller: 'yahoo_proxy'
                    }
                },

                directorySpotProxy: {
                    method: 'POST',
                    params: {
                        controller: 'directoryspot_proxy'
                    },
                    isArray: false
                },

                hoursReport: {
                    method: 'POST',
                    params: {
                        controller: 'hours_report'
                    }
                },

                pricingPlans: {
                    method: 'GET',
                    params: {
                        controller: 'pricing_plans'
                    },
                    cache: true
                },

                validatePromoCode: {
                    method: 'POST',
                    params: {
                        controller: 'is_promo_valid'
                    }
                },

                getUnsubscribePreferences: {
                    method: 'GET',
                    params: {
                        controller: 'get_unsubscribe_preferences'
                    }
                },

                updateUnsubscribePreferences: {
                    method: 'PUT',
                    params: {
                        controller: 'post_unsubscribe_preferences'
                    }
                }
            }
        );
    }];
});
